export default __webpack_public_path__ + "static/media/mic-off.709b1353.svg";